module.exports = __webpack_public_path__ + "img/logout.93f16baa.svg";